import { ListItem } from '@mui/joy';
import styles from './DataListItem.module.css';

interface DataListItemProps {
  label: string;
  value: string | number;
  fullWidth?: boolean;
}

function DataListItem({ label, value, fullWidth }: DataListItemProps) {
  if (!value) {
    return null;
  }

  let classes = styles.listItem;
  if (fullWidth) {
    classes += ` ${styles.fullWidth}`;
  }

  return (
    <ListItem component="div" className={classes}>
      <dt className={`sd-label-sm ${styles.label}`}>{label}</dt>
      <dd className={`sd-body-md ${styles.value}`}>{value}</dd>
    </ListItem>
  );
}

export default DataListItem;
